import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-field-number-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [class]="iconClass()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.02667 6.44444L7.74933 13.5556M12.1378 6.44444L10.8604 13.5556M13.8062 8.44444H6.19378M13.8062 11.5556H6.19378M2 7.68889C2 5.69778 2 4.70222 2.38756 3.94133C2.72843 3.27234 3.27234 2.72843 3.94133 2.38756C4.70222 2 5.69778 2 7.68889 2H12.3111C14.3022 2 15.2978 2 16.0587 2.38756C16.7277 2.72843 17.2716 3.27234 17.6124 3.94133C18 4.70222 18 5.69778 18 7.68889V12.3111C18 14.3022 18 15.2978 17.6124 16.0587C17.2716 16.7277 16.7277 17.2716 16.0587 17.6124C15.2978 18 14.3022 18 12.3111 18H7.68889C5.69778 18 4.70222 18 3.94133 17.6124C3.27234 17.2716 2.72843 16.7277 2.38756 16.0587C2 15.2978 2 14.3022 2 12.3111V7.68889Z"
        stroke="#F59E0B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class FieldNumberIconComponent extends BaseIconComponent {}
